export const ANALYTICS_EVENTS = {
    SIGNUP: "sign_up",
    VIEW_SUBSCRIPTION_PLANS: 'subscription_plan_view',
    SUBSCRIPTION_START: 'subscription_start',
    SUBSCRIPTION_SUCCESS: 'subscription_success',
    SUBSCRIPTION_FAILED: 'subscription_failed',
    SUBSCRIPTION_CANCELED: 'subscription_canceled',
    SUBSCRIPTION_TRIAL_VIEW: 'subscription_trial_view',
    SUBSCRIPTION_TRIAL_START: 'subscription_trial_start',
    SUBSCRIPTION_TRIAL_SUCCESS: 'subscription_trial_success',
    SUBSCRIPTION_TRIAL_FAILED: 'subscription_trial_failed',
    SUBSCRIPTION_CHANGE_START: 'subscription_change_start',
    SUBSCRIPTION_CHANGE_SUCCESS: 'subscription_change_success',
    SUBSCRIPTION_CHANGE_FAILED: 'subscription_change_failed',
};